import { tokens } from '@hotjar/hotsauce';
import * as d3 from 'd3';

/**
 * Returns the scale of colours to be used in the coverage level graphic.
 */
export const getGaugeColorScale = (): d3.ScaleLinear<string, string> => {
  const colorsRange = [
    tokens.color.text_warning,
    tokens.BRAND_COLORS.ember_700,
    tokens.BRAND_COLORS.ember_700,
    tokens.BRAND_COLORS.mint_700,
    tokens.BRAND_COLORS.mint_700,
  ];

  return d3.scaleLinear<string>().domain([0, 25, 50, 75, 100]).range(colorsRange);
};
